(function () {
  const TAG_MESSAGES = {
    "buy 2 for $75": "Buy 2 for $75",  // ← key lowercase, value is display text
  };

  function normalize(tag) {
    return String(tag || "").trim().toLowerCase();
  }

  function getMessageFromTags(tags) {
    for (const t of tags) {
      const key = normalize(t);
      if (TAG_MESSAGES[key]) return TAG_MESSAGES[key];
    }
    return "";
  }

  function applyMessages(root = document) {
    const nodes = root.querySelectorAll(".tag-promo-message[data-product-tags]");
    nodes.forEach((el) => {
      const raw = el.getAttribute("data-product-tags") || "";
      const tags = raw.split(",").map(normalize).filter(Boolean);

      const msg = getMessageFromTags(tags);

      if (msg) {
        el.textContent = msg;
        el.style.display = "";
      } else {
        el.textContent = "";
        el.style.display = "none";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => applyMessages());
  document.addEventListener("shopify:section:load", (e) => applyMessages(e.target));
})();